<!-- <!doctype html>
<html class="no-js h-100" lang="en"> -->
  <!-- <head> -->
    <link href="https://use.fontawesome.com/releases/v5.0.6/css/all.css" rel="stylesheet">
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
    <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
  <!-- </head> -->
  <!-- <body class="h-100"> -->

    <style type="text/css">
      /*#section07 { background: url(https://picsum.photos/1200/800?image=675) center center / cover no-repeat;}*/
      @import url(https://fonts.googleapis.com/css?family=Josefin+Sans:300,400);

      
      .demo a {
        position: absolute;
        bottom: 20px;
        left: 50%;
        z-index: 2;
        display: inline-block;
        -webkit-transform: translate(0, -50%);
        transform: translate(0, -50%);
        color: #fff;
        font : normal 400 20px/1 'Josefin Sans', sans-serif;
        letter-spacing: .1em;
        text-decoration: none;
        transition: opacity .3s;
      }
      .demo a:hover {
        opacity: .5;
      }

      #section07 a {
        padding-top: 110px;
        padding-left: 70px;

      }

      #section07 a span {
        position: absolute;
        top: 0;
        left: 50%;
        width: 24px;
        height: 24px;
        margin-left: -12px;
        border-left: 1px solid #0a0a0a;
        border-bottom: 1px solid #0a0a0a;
        -webkit-transform: rotate(-45deg);
        transform: rotate(-45deg);
        -webkit-animation: sdb07 2s infinite;
        animation: sdb07 2s infinite;
        opacity: 0;
        box-sizing: border-box;
      }
      #section07 a span:nth-of-type(1) {
        -webkit-animation-delay: 0s;
        animation-delay: 0s;
      }
      #section07 a span:nth-of-type(2) {
        top: 16px;
        -webkit-animation-delay: .15s;
        animation-delay: .15s;
      }
      #section07 a span:nth-of-type(3) {
        top: 32px;
        -webkit-animation-delay: .3s;
        animation-delay: .3s;
      }

      @-webkit-keyframes sdb07 {
      0% {
        opacity: 0;
      }
      50% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
    @keyframes sdb07 {
      0% {
        opacity: 0;
      }
      50% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }

    </style>
    <div class="container-fluid">
      <div class="row">
        
        <main class="main-content col-lg-12 col-md-12 col-sm-12 p-0">
          <div class="main-navbar sticky-top bg-white">
            <!-- Main Navbar -->
            <nav class="">
              <form action="#" class="">
                <div class="">

                    <div class="row" *ngIf="viewSection=='Quarter'">

                      <div class="form-group col-md-2" style="margin-top: 10px;">
                        <a href="http://www.gicouncil.in/" target="_blank"><img src="./assets/dashboard/images/gic-header-logo.jpg" class="responsive" style="height: 45px; margin-left: 20px;" alt="Gic Logo" /></a>
                      </div>
                      <div class="form-group col-md-2" style="margin-top: 10px;">
                        <select name="quarterYear" id="quarterYear" [(ngModel)]="quarterYear" (change)="genQuarterPremPol()" class="form-control">
                          <option>Choose Year</option>
                          <option value="{{yr}}" *ngFor="let yr of qYrArr">{{yr}}</option>
                        </select>
                      </div>
                      <div class="form-group col-md-2" style="margin-top: 10px;">
                        <select name="quarterQuarter" id="quarterQuarter" [(ngModel)]="quarterQuarter" class="form-control" (change)="genQuarterPremPol()">
                          <option>Choose Quarter</option>
                          <option value="{{qtr}}" *ngFor="let qtr of qQtrArr">{{qtr}}</option>
                        </select>
                      </div>

                      <div class="form-group col-md-2" style="margin-top: 10px;">
                        <select name="quarterLob" id="quarterLob" [(ngModel)]="quarterLob" class="form-control" (change)="genQuarterPremPol()">
                          <option>Select Segment</option>
                          <option value="All" >All</option>
                          <option value="{{l}}" *ngFor="let l of qLobArr">{{l}}</option>
                        </select>
                      </div>

                      <div class="form-group col-md-2" style="margin-top: 10px;">
                        <select name="quarterLoc" id="quarterLoc" [(ngModel)]="quarterLoc" class="form-control" (change)="genQuarterPremPol()">
                          <option>Select Location</option>
                          <option value="All" >All</option>
                          <option value="{{loc}}" *ngFor="let loc of qLocArr">{{loc}}</option>
                        </select>
                      </div>

                      <div class="form-group col-md-2" style="margin-top: 10px;">
                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                          <label class="btn btn-white">
                            <input type="radio" name="optradio" (click)="chnageView('Month')"> Month </label>
                          <label class="btn btn-white active">
                            <input type="radio" name="optradio" checked> Quarter </label>
                        </div>
                      </div>

                    </div>

                    <div class="row" *ngIf="viewSection=='Month'">

                      <div class="form-group col-md-2" style="margin-top: 10px;">
                        <img src="./assets/dashboard/images/gic-header-logo.jpg" class="responsive" style="height: 45px; margin-left: 20px;" alt="Gic Logo" />
                      </div>
                      <div class="form-group col-md-2" style="margin-top: 10px;">
                        <select name="monthYear" id="monthYear" [(ngModel)]="monthYear" class="form-control" (change)="genMonthPremNPol()">
                          <option value="{{yr.year}}" *ngFor="let yr of mnthYrArr">{{yr.year}}</option>
                        </select>
                      </div>
                      <div class="form-group col-md-2" style="margin-top: 10px;">
                        <select name="monthLob" id="monthLob" [(ngModel)]="monthLob" class="form-control" (change)="genMonthPremNPol()">
                          <option value="{{l.lob}}" *ngFor="let l of mnthnLobArr">{{l.lob}}</option>
                        </select>
                      </div>

                      <div class="form-group col-md-2" style="margin-top: 10px;">
                        <select name="monthInsurer" id="monthInsurer" [(ngModel)]="monthInsurer" class="form-control" (change)="genMonthPremNPol()">
                          <option value="All">All</option>
                          <option value="{{l.insurer}}" *ngFor="let l of mnthInsArr">{{l.insurer}}</option>
                        </select>
                      </div>

                      <div class="form-group col-md-2" style="margin-top: 10px;">
                      </div>

                      <div class="form-group col-md-2" style="margin-top: 10px;">
                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                          <label class="btn btn-white active">
                            <input type="radio" name="optradio" checked > Month </label>
                          <label class="btn btn-white">
                            <input type="radio" name="optradio" (click)="chnageView('Quarter')"> Quarter </label>
                        </div>
                      </div>

                    </div>
                </div>
              </form>
              <nav class="nav">
                <a href="#" class="nav-link nav-link-icon toggle-sidebar d-md-inline d-lg-none text-center border-left" data-toggle="collapse" data-target=".header-navbar" aria-expanded="false" aria-controls="header-navbar">
                  <i class="material-icons">&#xE5D2;</i>
                </a>
              </nav>
            </nav>
          </div>
          <!-- / .main-navbar -->
          <div class="main-content-container container-fluid px-4">
            <!-- Page Header -->
            <!-- End Page Header -->
            <!-- Small Stats Blocks -->
            <div class="row" style="margin-top: 20px;">
              <div class="col-lg col-md-6 col-sm-6 mb-4">
                <div class="stats-small stats-small--1 card card-small">
                  <div class="card-body p-0 d-flex">
                    <div class="d-flex flex-column m-auto">
                      <div class="stats-small__data text-center">
                        <span class="stats-small__label text-uppercase">GDPI</span>

                        
                        <h6 class="stats-small__value count my-3">{{gdpi}}</h6>
                      </div>
                      <div class="stats-small__data">
                        <span class="stats-small__percentage">( ₹ in Lacs. )</span>
                      </div>
                    </div>
                    <!-- <canvas height="120" class="blog-overview-stats-small-1"></canvas> -->
                  </div>
                </div>
              </div>
              <div class="col-lg col-md-6 col-sm-6 mb-4">
                <div class="stats-small stats-small--1 card card-small">
                  <div class="card-body p-0 d-flex">
                    <div class="d-flex flex-column m-auto">
                      <div class="stats-small__data text-center">
                        <span class="stats-small__label text-uppercase">Claims Reported</span>
                        <h6 class="stats-small__value count my-3">{{amtClaimRep}}</h6>
                      </div>
                      <div class="stats-small__data">
                        <span class="stats-small__percentage">( Amount - ₹ in Lacs. )</span>
                      </div>
                    </div>
                    <!-- <canvas height="120" class="blog-overview-stats-small-1"></canvas> -->
                  </div>
                </div>
              </div>
              <div class="col-lg col-md-6 col-sm-6 mb-4">
                <div class="stats-small stats-small--1 card card-small">
                  <div class="card-body p-0 d-flex">
                    <div class="d-flex flex-column m-auto">
                      <div class="stats-small__data text-center">
                        <span class="stats-small__label text-uppercase">Claims Paid</span>
                        <h6 class="stats-small__value count my-3">{{amtClaimPaid}}</h6>
                      </div>
                      <div class="stats-small__data">
                        <span class="stats-small__percentage">( Amount - ₹ in Lacs. )</span>
                      </div>
                    </div>
                    <!-- <canvas height="120" class="blog-overview-stats-small-2"></canvas> -->
                  </div>
                </div>
              </div>
              <div class="col-lg col-md-4 col-sm-6 mb-4">
                <div class="stats-small stats-small--1 card card-small">
                  <div class="card-body p-0 d-flex">
                    <div class="d-flex flex-column m-auto">
                      <div class="stats-small__data text-center">
                        <span class="stats-small__label text-uppercase">Policy Count</span>
                        <h6 class="stats-small__value count my-3">{{pc}}</h6>
                      </div>
                      <div class="stats-small__data">
                        <span class="stats-small__percentage">(In Numbers)</span>
                      </div>
                    </div>
                    <!-- <canvas height="120" class="blog-overview-stats-small-3"></canvas> -->
                  </div>
                </div>
              </div>
              <div class="col-lg col-md-4 col-sm-6 mb-4">
                <div class="stats-small stats-small--1 card card-small">
                  <div class="card-body p-0 d-flex">
                    <div class="d-flex flex-column m-auto">
                      <div class="stats-small__data text-center">
                        <span class="stats-small__label text-uppercase">Claims Reported</span>
                        <h6 class="stats-small__value count my-3">{{nocRep}}</h6>
                      </div>
                      <div class="stats-small__data">
                        <span class="stats-small__percentage">(In Numbers)</span>
                      </div>
                    </div>
                    <!-- <canvas height="120" class="blog-overview-stats-small-4"></canvas> -->
                  </div>
                </div>
              </div>
              <div class="col-lg col-md-4 col-sm-12 mb-4">
                <div class="stats-small stats-small--1 card card-small">
                  <div class="card-body p-0 d-flex">
                    <div class="d-flex flex-column m-auto">
                      <div class="stats-small__data text-center">
                        <span class="stats-small__label text-uppercase">Claims Paid</span>
                        <h6 class="stats-small__value count my-3">{{nocPaid}}</h6>
                      </div>
                      <div class="stats-small__data">
                        <span class="stats-small__percentage">(In Numbers)</span>
                      </div>
                    </div>
                    <!-- <canvas height="120" class="blog-overview-stats-small-5"></canvas> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- End Small Stats Blocks -->
            <div *ngIf="viewSection=='Quarter'" style="margin-top: -30px;">
              
              <div class="row" style="margin-bottom: -30px;">
                <!-- Users Stats -->
                <div class="col-lg-10 col-md-12 col-sm-12 mb-4">
                  <div class="card card-small">
                    <div class="card-header border-bottom">
                      <div class="row">
                        <div class="col-md-9">
                          <h6 class="m-0">Statewise Premium & Policy - {{quarterLob}}</h6>
                        </div>
                        <div class="form-group col-md-3">
                            <div class="btn-group btn-group-toggle pull-right" data-toggle="buttons">
                              <label class="btn btn-white" name="" [ngClass]="{'active':viewSubSelect == 'premium' }" (click)="chnageSubView('premium')">
                                <input type="radio" name="options" id="option1" autocomplete="off"> Premium </label>
                              <label class="btn btn-white" name="" [ngClass]="{'active':viewSubSelect == 'policy' }" (click)="chnageSubView('policy')">
                                <input type="radio" name="options" id="option2" autocomplete="off"> Policies </label>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-body pt-0">
                      <div class="panel-body" [chart]="statPolPremchart">
                        
                      </div>
                      <!-- <canvas id="ctx" width="700"></canvas>
                      <canvas height="1" style="max-width: 100% !important;" class="blog-overview-users"></canvas> -->
                    </div>
                  </div>
                </div>
                <!-- End Users Stats -->
                <!-- Discussions Component -->
                <div class="col-lg-2 col-md-6 col-sm-12 mb-4">
                  <div class="card card-small blog-comments">
                    <div class="card-header border-bottom">
                      <h6 class="m-0">State-wise Premium & Policy Chart</h6>
                    </div>
                    <div class="card-body p-0" style="margin-bottom: 10px;">
                      <div class="blog-comments__item d-flex p-3">
                        <div class="blog-comments__content">
                          <div class="blog-comments__meta text-muted">
                            <a class="text-secondary">What this tells you?</a>
                            <section id="section07" class="demo">
                              <h1></h1>
                              <a href="dashboard#secondsection"><span></span><span></span><span></span>Scroll</a>
                            </section> 
                          </div>
                          <p class="m-0 my-1 mb-2 text-muted">Premium & Policy for each State/UT</p>
                          <p class="m-0 my-1 mb-2 text-muted">General Insurer, Specialized Insurer and Standalone Insurer are represented with Blue,Yellow & Pink Respectively</p>
                        </div>
                      </div>
                      <div class="blog-comments__item d-flex p-3">
                        <div class="blog-comments__content">
                          <div class="blog-comments__meta text-muted">
                            <a class="text-secondary">What you can do?</a>
                          </div>
                          <p class="m-0 my-1 mb-2 text-muted">Select Quarter, Segment, Location from the dropdown on the top.</p>
                        </div>
                        <div id="secondsection"></div>
                      </div>                 
                    </div>
                  </div>
                </div>
              </div>

              
              <div class="row" style="margin-bottom: -30px;">
                <!-- Users Stats -->
                <div class="col-lg-10 col-md-12 col-sm-12 mb-4" >
                  <div class="card card-small">
                    <div class="card-header border-bottom">
                      <div class="row">
                        <div class="col-md-9">
                          <h6 class="m-0">Statewise Claims Reported - {{quarterLob}}</h6>
                        </div>
                        <div class="form-group col-md-3">
                            <div class="btn-group btn-group-toggle pull-right" data-toggle="buttons">
                              <label class="btn btn-white" name="" [ngClass]="{'active':viewSubSelect == 'premium' }" (click)="chnageSubView('premium')">
                                <input type="radio" name="options" id="option1" autocomplete="off" checked=""> Amount </label>
                              <label class="btn btn-white" name="" [ngClass]="{'active':viewSubSelect == 'policy' }" (click)="chnageSubView('policy')">
                                <input type="radio" name="options" id="option2" autocomplete="off"> Count </label>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-body pt-0">
                      <div class="panel-body" [chart]="statClaimchart">
                      </div>
                      <!-- <canvas id="ctx" width="700"></canvas>
                      <canvas height="1" style="max-width: 100% !important;" class="blog-overview-users"></canvas> -->
                    </div>
                  </div>
                </div>
                <!-- End Users Stats -->
                <!-- Discussions Component -->
                <div class="col-lg-2 col-md-6 col-sm-12 mb-4">
                  <div class="card card-small blog-comments">
                    <div class="card-header border-bottom">
                      <h6 class="m-0">State-wise Claims Reported - All</h6>
                    </div>
                    <div class="card-body p-0" style="margin-bottom: 10px;">
                      <div class="blog-comments__item d-flex p-3">
                        <div class="blog-comments__content">
                          <div class="blog-comments__meta text-muted">
                            <a class="text-secondary">What this tells you?</a> 
                          </div>
                          <p class="m-0 my-1 mb-2 text-muted">Premium & Policy for each State/UT</p>
                          <p class="m-0 my-1 mb-2 text-muted">General Insurer, Specialized Insurer and Standalone Insurer are represented with Blue,Yellow & Pink Respectively</p>
                        </div>
                      </div>
                      <section id="section07" class="demo">
                        <h1></h1>
                        <a href="dashboard#thirdsection"><span></span><span></span><span></span>Scroll</a>
                      </section>
                      <div class="blog-comments__item d-flex p-3">
                        <div class="blog-comments__content">
                          <div class="blog-comments__meta text-muted">
                            <a class="text-secondary">What you can do?</a>
                          </div>
                          <div id="thirdsection"></div>
                          <p class="m-0 my-1 mb-2 text-muted">Select Quarter, Segment, Location from the dropdown on the top.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="row">
                <!-- Users By Device Stats -->
                <div class="col-lg-10 col-md-12 col-sm-12 mb-4">
                  <div class="card card-small h-100">
                    <div class="card-header">
                      <div class="row">
                        <div class="col-md-9">
                          <h6 class="m-0">Channelwise Paid Claims - {{quarterLob}}</h6>
                        </div>
                        <div class="form-group col-md-3">
                            <div class="btn-group btn-group-toggle pull-right" data-toggle="buttons">
                              <label class="btn btn-white active" name="" [ngClass]="{'active':viewSubSelect == 'premium' }" (click)="chnageSubView('premium')">
                                <input type="radio" name="options" id="option1" autocomplete="off" checked=""> Premium </label>
                              <label class="btn btn-white" name="" [ngClass]="{'active':viewSubSelect == 'policy' }" (click)="chnageSubView('policy')">
                                <input type="radio" name="options" id="option2" autocomplete="off"> Policies </label>
                            </div>
                        </div>
                      </div>
                    </div>
                      <div class="panel-body" [chart]="chClaimChart">

                      </div>
                     <!-- <canvas id="doughnut-chart" width="700" height="300"></canvas> -->
                  </div>
                </div>
                <!-- End Users By Device Stats -->

                <!-- Discussions Component -->
                <div class="col-lg-2 col-md-6 col-sm-12 mb-4">
                  <div class="card card-small blog-comments" style="margin-bottom: 0;">
                    <div class="card-header border-bottom">
                      <h6 class="m-0">Channelwise Paid Claims Chart</h6>
                    </div>
                    <div class="card-body p-0" style="margin-bottom: 79px;">
                      <div class="blog-comments__item d-flex p-3">
                        <div class="blog-comments__content">
                          <div class="blog-comments__meta text-muted">
                            <a class="text-secondary">What this tells you?</a> 
                          </div>
                          <p class="m-0 my-1 mb-2 text-muted">Channel wise paid claims for various type of Channel</p>
                        </div>
                      </div>
                      <section id="section07" class="demo">
                        <h1></h1>
                        <a href="dashboard#lastsection"><span></span><span></span><span></span>Scroll</a>
                      </section>
                      <div class="blog-comments__item d-flex p-3">
                        <div class="blog-comments__content">
                          <div class="blog-comments__meta text-muted">
                            <a class="text-secondary">What you can do?</a>
                          </div>
                          <p class="m-0 my-1 mb-2 text-muted">Select Quarter,Segment from the dropdown on the top.</p>
                          <p class="m-0 my-1 mb-2 text-muted">Toggle Between Amount & Count for detailed analysis.</p>
                        </div>
                      </div>
                      <div id="lastsection"></div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="row">
                <!-- Users By Device Stats -->
                <div class="col-lg-10 col-md-12 col-sm-12 mb-4">
                  <div class="card card-small h-100">
                    <div class="card-header">
                      <div class="row">
                        <div class="col-md-9">
                          <h6 class="m-0">Channelwise Premium & Policies - {{quarterLob}}</h6>
                        </div>
                        <div class="form-group col-md-3">
                            <div class="btn-group btn-group-toggle pull-right" data-toggle="buttons">
                              <label class="btn btn-white" name="" [ngClass]="{'active':viewSubSelect == 'premium' }" (click)="chnageSubView('premium')">
                                <input type="radio" name="options" id="option1" autocomplete="off" checked=""> Premium </label>
                              <label class="btn btn-white" name="" [ngClass]="{'active':viewSubSelect == 'policy' }" (click)="chnageSubView('policy')">
                                <input type="radio" name="options" id="option2" autocomplete="off"> Policies </label>
                            </div>
                        </div>
                      </div>
                    </div>
                      <div class="panel-body" [chart]="chPolPremChart"></div>
                      <!-- <canvas id="doughnut-chart" width="700" height="300"></canvas> -->
                  </div>
                </div>
                <!-- End Users By Device Stats -->

                <!-- Discussions Component -->
                <div class="col-lg-2 col-md-6 col-sm-12 mb-4">
                  <div class="card card-small blog-comments" style="margin-bottom: 0;">
                    <div class="card-header border-bottom">
                      <h6 class="m-0">Channelwise Premium & Policies - All</h6>
                    </div>
                    <div class="card-body p-0" style="margin-bottom: 79px;">
                      <div class="blog-comments__item d-flex p-3">
                        <div class="blog-comments__content">
                          <div class="blog-comments__meta text-muted">
                            <a class="text-secondary">What this tells you?</a> 
                          </div>
                          <p class="m-0 my-1 mb-2 text-muted">Channel wise Premium & Policy for various type of Channel</p>
                        </div>
                      </div>
                      <div class="blog-comments__item d-flex p-3">
                        <div class="blog-comments__content">
                          <div class="blog-comments__meta text-muted">
                            <a class="text-secondary">What you can do?</a>
                          </div>
                          <p class="m-0 my-1 mb-2 text-muted">Select Quarter,Segment from the dropdown on the top.</p>
                          <p class="m-0 my-1 mb-2 text-muted">Toggle Between Amount & Count for detailed analysis.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div *ngIf="viewSection=='Month'" style="margin-top: -30px;">

              <div class="row" style="margin-bottom: -30px;">
                <!-- Users Stats -->
                <div class="col-lg-10 col-md-12 col-sm-12 mb-4">
                  <div class="card card-small">
                    <div class="card-header border-bottom">
                      <div class="row">
                        <div class="col-md-9">
                          <h6 class="m-0">Premium - {{monthLob}}</h6>
                        </div>
                      </div>
                    </div>
                    <div class="card-body pt-0">
                      <div class="panel-body" [chart]="chart">
          
                      </div>
                      <!-- <canvas id="ctx" width="700"></canvas>
                      <canvas height="1" style="max-width: 100% !important;" class="blog-overview-users"></canvas> -->
                    </div>
                  </div>
                </div>
                <!-- End Users Stats -->
                <!-- Discussions Component -->
                <div class="col-lg-2 col-md-6 col-sm-12 mb-4">
                  <div class="card card-small blog-comments">
                    <div class="card-header border-bottom">
                      <h6 class="m-0">State-wise Premium & Policy Chart</h6>
                    </div>
                    <div class="card-body p-0" style="margin-bottom: 73px;">
                      <div class="blog-comments__item d-flex p-3">
                        <div class="blog-comments__content">
                          <div class="blog-comments__meta text-muted">
                            <a class="text-secondary">What this tells you?</a> 
                          </div>
                          <p class="m-0 my-1 mb-2 text-muted">An Overview of Month on Month Premium Collected  along with trend that follows</p>
                        </div>
                      </div>
                      <div class="blog-comments__item d-flex p-3">
                        <div class="blog-comments__content">
                          <div class="blog-comments__meta text-muted">
                            <a class="text-secondary">What you can do?</a>
                          </div>
                          <p class="m-0 my-1 mb-2 text-muted">Select Insurer, Year, Segment from the dropdown given on the top.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="row">
                <!-- Users Stats -->
                <div class="col-lg-10 col-md-12 col-sm-12 mb-4">
                  <div class="card card-small">
                    <div class="card-header border-bottom">
                      <div class="row">
                        <div class="col-md-9">
                          <h6 class="m-0">Policies - {{monthLob}}</h6>
                        </div>
                      </div>
                    </div>
                    <div class="card-body pt-0">
                      <div class="panel-body" [chart]="mgpchart">
          
                      </div>
                      <!-- <canvas id="ctx" width="700"></canvas>
                      <canvas height="1" style="max-width: 100% !important;" class="blog-overview-users"></canvas> -->
                    </div>
                  </div>
                </div>
                <!-- End Users Stats -->
                <!-- Discussions Component -->
                <div class="col-lg-2 col-md-6 col-sm-12 mb-4">
                  <div class="card card-small blog-comments">
                    <div class="card-header border-bottom">
                      <h6 class="m-0">State-wise Claims Reported - All</h6>
                    </div>
                    <div class="card-body p-0" style="margin-bottom: 73px;">
                      <div class="blog-comments__item d-flex p-3">
                        <div class="blog-comments__content">
                          <div class="blog-comments__meta text-muted">
                            <a class="text-secondary">What this tells you?</a> 
                          </div>
                          <p class="m-0 my-1 mb-2 text-muted">An Overview of Month on Month Policies Collected  along with trend that follows</p>
                        </div>
                      </div>
                      <div class="blog-comments__item d-flex p-3">
                        <div class="blog-comments__content">
                          <div class="blog-comments__meta text-muted">
                            <a class="text-secondary">What you can do?</a>
                          </div>
                          <p class="m-0 my-1 mb-2 text-muted">Select Insurer, Year, Segment from the dropdown given on the top.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="row">
              <div class="col-md-6 pull-left">
                {{configVal}}
              </div>
              <div class="col-md-6">
                <span class="pull-right">Designed by <a href="https://www.pentationanalytics.com/" target="_blank">Pentation Analytics</a></span>
              </div>
            </div>

          </div>
        </main>
      </div>
    </div>
    <script src="https://code.jquery.com/jquery-3.3.1.min.js" integrity="sha256-FgpCb/KJQlLNfOu91ta32o/NMZxltwRo8QtmkMRdAu8=" crossorigin="anonymous"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.3/umd/popper.min.js" integrity="sha384-ZMP7rVo3mIykV+2+9J3UJ46jBk0WLaUAdn689aCwoqbBJiSnjAK/l8WvCWPIPm49" crossorigin="anonymous"></script>
    <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/js/bootstrap.min.js" integrity="sha384-ChfqqxuZUCnJSK3+MXmPNIyE6ZbWh2IMqE241rYiqJxyMiZ6OW/JmZQ5stwEULTy" crossorigin="anonymous"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.7.1/Chart.min.js"></script>
    <script src="https://unpkg.com/shards-ui@latest/dist/js/shards.min.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/Sharrre/2.0.1/jquery.sharrre.min.js"></script>
    <script src="./assets/dashboard/scripts/extras.1.1.0.min.js"></script>
    <script src="./assets/dashboard/scripts/shards-dashboards.1.1.0.min.js"></script>
    <script src="./assets/dashboard/scripts/app/app-blog-overview.1.1.0.js"></script>


  <!-- </body>
</html> -->